import React from 'react'

import { Box, Typography } from '@material-ui/core'

const CardBenefit = ({ image, imageAlt, description }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      flex="1"
      my={2}
      p={2}
    >
      <Box height={80} mb={2}>
        <img src={image} alt={imageAlt} />
      </Box>

      <Typography color="textSecondary" align="center">
        {description}
      </Typography>
    </Box>
  )
}

export default CardBenefit
